import { render } from "./NoteBar.vue?vue&type=template&id=616bfd2f&scoped=true"
import script from "./NoteBar.vue?vue&type=script&lang=js"
export * from "./NoteBar.vue?vue&type=script&lang=js"

import "./NoteBar.vue?vue&type=style&index=0&id=616bfd2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616bfd2f"]])

export default __exports__